export default "__VITE_ASSET__DbsWoLhP__"